/**
 * Popper config for embed-forms list ⋮ action menus (fixed positioning + reveal after layout).
 */
const embedActionsMenuSecondPass = {
    name: "embedActionsMenuSecondPass",
    enabled: true,
    phase: "afterWrite",
    fn({ state, instance }) {
        const ref = state.elements.reference;
        const popperEl = state.elements.popper;
        if (!ref || !popperEl) {
            return;
        }
        if (popperEl.getAttribute("data-embed-menu-ready") === "true") {
            return;
        }
        if (ref.__embedMenuRevealRafId != null) {
            return;
        }
        ref.__embedMenuRevealRafId = requestAnimationFrame(() => {
            ref.__embedMenuRevealRafId = null;
            instance.update();
            popperEl.setAttribute("data-embed-menu-ready", "true");
        });
    },
};

export const EMBED_FORMS_ACTIONS_MENU_POPPER = {
    strategy: "fixed",
    modifiers: [embedActionsMenuSecondPass],
};
